import InviteEndUsers from './Modals/InviteEndUsers';
import EmailClosedTicket from './Modals/EmailClosedTicket';
import EmailPlanningReport from './Modals/EmailPlanningReport';
import UpdateDocketDetails from './Modals/UpdateDocketDetails';
import { openCustomModal, openTextModalAction, closeModalAction } from '../../actions/modal';
import UpdatePMPopup from './Modals/UpdatePMPopup';
import AddUsersInTeam from '../team/Modals/AddUsersInTeam';
import { updateProjectDetail, removeTeamFromProject, blackListUserFromProject, whiteListUserFromProject } from '../../actions/project';
import { isScm, isCustomer, isCustomerAdmin, isCluster, isCustomerGroup } from '../../utils/role';
import { canActivateProjects, isAddNewProjectAllowed, isEditProjectAllowed } from '../../utils/access';
import { useSelector } from 'react-redux';
import EditChecklist from './Modals/EditChecklist';
import AddSla from './Modals/AddSla';
import AddMileStone from './Modals/AddMileStone';
import { removeUserFromTeam } from '../../actions/teams';
import EditProjectPo from './Modals/EditPo';
import { isMobileView } from '../../utils/utils';
import { ActivateProject } from './Modals/ActivateProject';

const editProject = {
    key: 'editProject',
    menuName: 'Edit project',
    menuIcon: 'save_as',
    iconColor: 'text-scogoorange',
    onClick: (item, dispatch, { openAndSetProjectDetails, setProjectDetailsMode }) => {
        openAndSetProjectDetails(item);
        setProjectDetailsMode('edit');
    },
};

const addSla = {
    key: 'add_sla',
    menuName: 'Add SLA',
    menuIcon: 'schedule',
    menuColor: 'text-scogoprimary',
    onClick: (project, dispatch) => {
        return dispatch(openCustomModal({
            heading: (
                <span className='text-black'>
                    Add SLA :&nbsp;<span className='text-scogobgsky text-font16'>{`${project?.name} | ${project.project_number}`}</span>
                </span>
            ),
            modalWidth: `${isMobileView ? '34rem' : '60rem'}`,
            modalHeight: 'auto',
            modalComponent: <AddSla projectId={project.id} />
        }))
    },
};


const editPo = {
    key: 'edit_po',
    menuName: 'Add/Edit PO',
    menuIcon: 'schedule',
    iconColor: 'text-scogoprimary',
    onClick: (project, dispatch) => {
        return dispatch(openCustomModal({
            heading: (
                <span className='text-black'>
                    Add/Edit PO :&nbsp;<span className='text-scogobgsky text-font16'>{`${project?.name} | ${project.project_number}`}</span>
                </span>
            ),
            modalWidth: `${isMobileView ? '33rem' : '60rem'}`,
            modalHeight: 'auto',
            modalComponent: <EditProjectPo project={project} />
        }))
    },
};

const tagPM = {
    key: 'tagPM',
    menuName: 'Tag PM',
    menuIcon: 'person_add',
    onClick: (item, dispatch, { }) => {
        return dispatch(
            openCustomModal({
                heading: 'Tag PM',
                modalWidth: '32rem',
                modalHeight: 'auto',
                modalComponent: <UpdatePMPopup projectDetail={item} />,
            })
        );
    },
};

const inviteEndUsers = {
    key: 'inviteEndUsers',
    menuName: 'Invite End Users',
    menuIcon: 'person_add',
    onClick: (item, dispatch, { }) => {
        return dispatch(
            openCustomModal({
                heading: 'Invite End Users',
                modalWidth: '70rem',
                modalHeight: 'auto',
                modalComponent: <InviteEndUsers projectDetail={item} />,
            })
        );
    },
};

const emailClosedTicketsReport = {
    key: 'emailClosedTicketsReport',
    menuName: 'Email Closed Tickets Report',
    menuIcon: 'mail',
    onClick: (item, dispatch, { }) => {
        const projectName = item?.project_name;
        return dispatch(
            openCustomModal({
                heading: `Email Closed Tickets Report | ${projectName}`,
                modalHeight: 'auto',
                modalWidth: 'auto',
                modalComponent: <EmailClosedTicket projectDetail={item} />,
            })
        );
    },
};

const emailPlanningReport = {
    key: 'emailPlanningReport',
    menuName: 'Email Planning Report',
    menuIcon: 'mail',
    onClick: (item, dispatch, { }) => {
        return dispatch(
            openCustomModal({
                heading: 'Email Planning Report',
                modalWidth: '45rem',
                modalHeight: 'auto',
                modalComponent: <EmailPlanningReport projectDetail={item} />,
            })
        );
    },
};

const enableHardCopyRequired = {
    key: 'enableHardCopyRequired',
    menuName: 'Enable Hard Copy Required',
    menuIcon: 'description',
    menuColor: 'text-scogoprimary',
    onClick: (project, dispatch, { }) => {
        const formName = 'enableHardCopyModalForm';
        return dispatch(
            openTextModalAction({
                heading: 'Enable Hard Copy Required',
                text: 'Are you sure you want to enable?',
                closeOnBackdropClick: false,
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Enable',
                        type: 'blue',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => {
                            dispatch(updateProjectDetail({ projectForm: { is_hard_copy_required: true }, projectId: project.id, formName }));
                        },
                    },
                    {
                        textOrComponent: 'Close',
                        type: 'redOutlined',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                    },
                ],
                formName,
            })
        );
    },
};

const disableHardCopyRequired = {
    menuName: 'Disable Hard Copy Required',
    menuIcon: 'block',
    menuColor: 'text-scogoprimary',
    onClick: (project, dispatch, { }) => {
        const formName = 'disableHardCopyModalForm';
        return dispatch(
            openTextModalAction({
                heading: 'Disable Hard Copy Required',
                text: 'Are you sure you want to disable?',
                closeOnBackdropClick: false,
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Disable',
                        type: 'red',
                        buttonClass: 'hover:bg-scogoLightFillRed',
                        onClick: () => {
                            dispatch(updateProjectDetail({ projectForm: { is_hard_copy_required: false }, projectId: project.id, formName }));
                        },
                    },
                    {
                        textOrComponent: 'Close',
                        type: 'blue',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                    },
                ],
                formName,
            })
        );
    },
};

const updateDocketDetails = {
    key: 'updateDocketDetails',
    menuName: 'Update Docket Details',
    menuIcon: 'local_shipping',
    onClick: (item, dispatch, { }) => {
        return dispatch(
            openCustomModal({
                heading: 'Update Docket Details',
                modalHeight: 'auto',
                modalWidth: '45rem',
                modalComponent: <UpdateDocketDetails projectDetail={item} />,
            })
        );
    },
};

const removeFromProject = {
    key: 'removeFromProject',
    menuName: 'Remove Team',
    menuIcon: 'delete',
    iconColor: 'text-scogoclosed',
    onClick: (item, dispatch, { team, projectDetail }) => {
        return dispatch(
            openTextModalAction({
                heading: 'Remove Team from project',
                text: 'Are you sure you want to continue?',
                closeOnBackdropClick: false,
                formName: 'removeTeamFromProject',
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Yes',
                        type: 'red',
                        buttonClass: 'hover:bg-scogoLightFillRed',
                        onClick: () => {
                            dispatch(
                                removeTeamFromProject({
                                    projectId: projectDetail?.id,
                                    team_ids: [team.id],
                                    formName: 'removeTeamFromProject',
                                })
                            );
                        },
                    },
                    {
                        textOrComponent: 'No',
                        type: 'blue',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                    },
                ],
            })
        );
    },
};

const addUsersInProjectTeam = {
    key: 'addUsersInProjectTeam',
    menuName: 'Add Users',
    menuIcon: 'person',
    iconColor: 'text-black',
    onClick: (item, dispatch, { projectDetail }) => {
        return dispatch(
            openCustomModal({
                heading: 'Add Users To Project Team',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <AddUsersInTeam projectDetails={projectDetail} teamDetails={item} tabName={'projects'} />,
            })
        );
    },
};

const removeUserFromTeamDropdownAction = {
    key: 'removeUserFromTeam',
    menuName: 'Remove from team',
    menuIcon: 'delete',
    iconColor: 'text-scogoclosed',
    onClick: (team, dispatch, { agent, projectDetail }) => {

        const formName = 'removeUserFromTeamInProject';
        return dispatch(
            openTextModalAction({
                heading: `Do you want to remove ${agent.display_name} from ${team.name}?`,
                text: 'Are you sure you want to continue?',
                closeOnBackdropClick: false,
                formName,
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Yes',
                        type: 'red',
                        buttonClass: 'hover:bg-scogoLightFillRed',
                        onClick: () => {
                            let payload = {
                                teamId: team.id,
                                userName: agent.display_name,
                                teamName: team.name,
                                members: [agent.id],
                                formName,
                                source: 'project',
                                projectId: projectDetail.id,
                            }
                            dispatch(removeUserFromTeam(payload));
                        },
                    },
                    {
                        textOrComponent: 'No',
                        type: 'blue',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                    },
                ],
            })
        );
    },
};

const addUserToProject = {
    key: 'add_to_project',
    menuName: 'Add To Project',
    menuIcon: 'add_task',
    iconColor: 'text-scogoToastSuccess',
    onClick: (team, dispatch, { agent, customerId, projectDetail }) => {
        const formName = 'updateUserStatusToWhitelist';
        return dispatch(
            openTextModalAction({
                heading: 'Add To Project',
                text: `Are you sure you want to add ${agent.display_name} to project?`,
                closeOnBackdropClick: false,
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Yes',
                        type: 'blue',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => {
                            dispatch(whiteListUserFromProject({ user_id: agent.id, projectId: projectDetail.id, formName, team_id: team.id }));
                        },
                    },
                    {
                        textOrComponent: 'No',
                        type: 'redOutlined',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                    },
                ],
                formName,
            })
        );
    },
};

const removeUserFromProject = {
    key: 'blackList',
    menuName: 'Remove from Project',
    menuIcon: 'block',
    iconColor: 'text-scogo99',
    onClick: (team, dispatch, { agent, projectDetail }) => {
        const formName = 'updateUserStatusToBlacklist';
        return dispatch(
            openTextModalAction({
                heading: 'Update User Status',
                text: `Are you sure you want to remove ${agent.display_name} from project?`,
                closeOnBackdropClick: false,
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Remove',
                        type: 'red',
                        buttonClass: 'hover:bg-scogoLightFillRed',
                        onClick: () => {
                            dispatch(blackListUserFromProject({ user_id: agent.id, projectId: projectDetail.id, formName, team_id: team.id }));
                        },
                    },
                    {
                        textOrComponent: 'Close',
                        type: 'blue',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                    },
                ],
                formName,
            })
        );
    },
};

const editChecklist = {
    key: 'editChecklist',
    menuName: 'Edit Checklist',
    menuIcon: 'checklist',
    onClick: (project, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: 'Edit Checklist',
                modalWidth: '70rem',
                modalHeight: 'auto',
                modalComponent: <EditChecklist project={project} />,
            })
        );
    },
};
const addMileStone = {
    key: 'addMileStone',
    menuName: 'Add Milestone',
    menuIcon: 'flag',
    onClick: (project, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: <span className='text-black'>
                    Add Milestone :&nbsp;<span className='text-scogobgsky text-font16'>{`${project.project_number}`}</span>
                </span>,
                modalWidth: `${isMobileView ? '35rem' : '70rem'}`,
                modalHeight: 'auto',
                modalComponent: <AddMileStone project={project} />,
            })
        );
    },
};

export const activateProject = {
    key: 'activateProject',
    menuName: 'Activate Project',
    menuIcon: 'play_arrow',
    iconColor: 'text-scogobgsky',
    onClick: (project, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: <span className='text-black'>
                    Activate Project :&nbsp;<span className='text-scogobgsky text-font16'>{`${project.project_number}`}</span>
                </span>,
                modalWidth: `${isMobileView ? '35rem' : '70vw'}`,
                modalHeight: 'auto',
                modalComponent: <ActivateProject project={project} />,
            })
        );
    },
};

export const updateBudget = {
    key: 'updateBudget',
    menuName: 'Update Budget',
    menuIcon: 'update',
    iconColor: 'text-scogobgsky',
    onClick: (project, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: <span className='text-black'>
                    Update Budget :&nbsp;<span className='text-scogobgsky text-font16'>{`${project.project_number}`}</span>
                </span>,
                modalWidth: `${isMobileView ? '35rem' : '70vw'}`,
                modalHeight: 'auto',
                modalComponent: <ActivateProject project={project} hidePo submitButtonText='Update Budget' />,
            })
        );
    },
};

export const deactivateProject = {
    key: 'deactivateProject',
    menuName: 'Deactivate Project',
    menuIcon: 'pause',
    iconColor: 'text-scogoclosed',
    onClick: (project, dispatch) => {
        const formName = 'deactivateProject';
        return dispatch(
            openTextModalAction({
                heading: 'Deactivate Project',
                text: `Are you sure you want to deactivate project?`,
                closeOnBackdropClick: false,
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Deactivate',
                        type: 'red',
                        buttonClass: 'hover:bg-scogoLightFillRed',
                        onClick: () => {
                            dispatch(updateProjectDetail({ projectForm: { status: ProjectStatus.INACTIVE }, projectId: project.id, formName, source: 'deactivate_project' }));
                        },
                    },
                    {
                        textOrComponent: 'Close',
                        type: 'blue',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                    },
                ],
                formName,
            })
        );
    },
};

export const GetShowAddProjectButton = () => {
    const { loggedUser } = useSelector((state) => state.auth);
    const role = loggedUser.role.id;
    const type = loggedUser.type;
    if (isScm(role, type) || isCustomerGroup(role, type)) return true;
    return false;
};

export const GetProjectTableLogic = (logic, { project } = {}) => {
    const { loggedUser } = useSelector((state) => state.auth);
    const role = loggedUser.role.id,
        type = loggedUser.type,
        frontend_controller = loggedUser.frontend_controller;
    if (logic === 'updateButton') return getUpdateButton(role, type, frontend_controller);
    else if (logic === 'editButton') return getEditButton(role, type, frontend_controller);
    else if (logic === 'addNewProjectTeam') return getAddTeamInProject(role, type);
    else if (logic === 'paymentEditButton') return getPaymentEditButton(role, type);
    else if (logic === 'additionalDetailsEditButton') return getAdditionalDetailsEditButton(role, type);
    else if (logic === 'isToShowPaymentDetails') return isToShowPaymentDetails(role, type);
    else if (logic === 'toShowCustomer') return checkIfCustomerShouldBeShown(role, type);
    return;
};

export const ProjectActionsEnum = {
    EDIT_PROJECT: 'EDIT_PROJECT',
    ADD_MILESTONE: 'ADD_MILESTONE',
    ADD_SLA: 'ADD_SLA',
}

export const ProjectStatus = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
}

export const canEditProject = (actions = []) => {
    const hasPermission = actions.find(({ action }) => action === ProjectActionsEnum.EDIT_PROJECT);
    return (!hasPermission || hasPermission && hasPermission.allowed);
}

export const getProjectActions = (project, newLoggedUserData) => {
    const actions = [editProject, addMileStone, addSla, editPo, editChecklist, activateProject, updateBudget, deactivateProject];
    return actions.filter((action) => {
        if ([editProject.key, addMileStone.key, addSla.key].includes(action.key)) {
            return isAddNewProjectAllowed(newLoggedUserData.actions);
        }

        if (action.key === deactivateProject.key || action.key === updateBudget.key) {
            return canActivateProjects(newLoggedUserData.actions) && project.status === ProjectStatus.ACTIVE;
        }

        if (action.key === activateProject.key) {
            return canActivateProjects(newLoggedUserData.actions) && project.status === ProjectStatus.INACTIVE;
        }

        return true;
    });
};

const getUpdateButton = (role, type, frontend_controller) => {
    if (isScm(role, type) || isCustomer(role, type) || isCustomerAdmin(role, type) || isCluster(role, type)) {
        return isEditProjectAllowed(frontend_controller);
    }
    return false;
};

const getEditButton = (role, type, frontend_controller) => {
    if (isScm(role, type) || isCustomer(role, type) || isCustomerAdmin(role, type) || isCluster(role, type)) {
        return isEditProjectAllowed(frontend_controller);
    }
    return false;
};

const getPaymentEditButton = (role, type) => {
    if (isScm(role, type)) {
        return true;
    }
    return false;
};
const getAdditionalDetailsEditButton = (role, type) => {
    if (isScm(role, type) || isCustomer(role, type) || isCustomerAdmin(role, type) || isCluster(role, type)) {
        return true;
    }
    return false;
};

const isToShowPaymentDetails = (role, type) => {
    if (isScm(role, type) || isCluster(role, type)) {
        return true;
    }
    return false;
};

const getAddTeamInProject = (role, type) => {
    if (isScm(role, type) || isCustomer(role, type) || isCustomerAdmin(role, type)) {
        return true;
    }
    return false;
};

export const getProjectTeamActions = () => {
    return [addUsersInProjectTeam, removeFromProject];
};

export const getProjectTeamUsersActions = (member) => {
    let actions = [addUserToProject, removeUserFromProject, removeUserFromTeamDropdownAction];

    return actions.filter((action) => {
        if (action.key === addUserToProject.key) {
            return member.isBlacklisted;
        } else if (action.key === removeUserFromProject.key) {
            return !member.isBlacklisted;
        }
        return true;
    });
};

export const preSelectedTeam = (teams) => {
    return teams?.filter((team) => {
        return team?.default === 1 && team?.type !== 'VENDOR';
    });
};

const checkIfCustomerShouldBeShown = (role, type) => {
    return isScm(role, type) || isCluster(role, type);
};




export const defaultRowsPerPage = 50;
export const defaultPage = 1;
